import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6cf16c40"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "screening" }
const _hoisted_2 = {
  key: 2,
  class: "screening__container"
}

import { computed, onMounted, onUnmounted, reactive, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { commentApi, patientApi, userApi } from '@/shared/api'
import { showErrorMessage } from '@/shared/utils'
import WReportHeader from '@/widgets/WReportHeader/WReportHeader.vue'
import CpitnWhiteCard from '@/pages/ScreeningPage/components/CpitnWhiteCard.vue'
import IndexBloodingWhiteCard from '@/pages/ScreeningPage/components/IndexBloodingWhiteCard.vue'
import ScreeningReportPreview from '@/pages/ScreeningPage/components/ScreeningReportPreview.vue'
import { screeningReportApi } from '@/shared/api/report/screeningReport.api'
import { ElMessage } from 'element-plus'
import { useReportListing } from '@/shared/composables'
import WReportComments from '@/widgets/WReportComments/WReportComments.vue'
import { WReportSubmit } from '@/widgets/WReportSubmit'
import { WReportPrint } from '@/widgets/WReportPrint'
import { REPORT_VIEW } from '@/shared/constants'
import ScreeningRecommendations from '@/pages/ScreeningPage/components/ScreeningRecommendations.vue'
import { ScreeningController } from '@/pages/ScreeningPage/screeningController'
import WSendToBot from '@/widgets/WSendToBot/WSendToBot.vue'
import { CommentTemplateType } from '@/shared/types'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()
const router = useRouter()
const loading = ref(false)
const isLinkedPatient = ref(false)
const isSendedReport = ref(false)
const reportId = computed(() => Number(route.params.reportId))
const patientId = computed(() => Number(route.params.patientId))
const userId = ref(null)
const isCreationPage = computed(() => route.params.reportId === '0')
const isPreviewMode = computed(() => route.query['view-mode'] === '1')

const { setUpdateReportListing } = useReportListing()

const reportInfo = ref({
  id: reportId,
  date_at: '',
  doctor: undefined,
})

const templates = ref([])
const comments = ref([])
const organization = ref({
  logo: {
    id: '',
  },
  name: '',
  address: '',
  site: '',
  phone: '',
})
const scrInt = new ScreeningController()
const screeningController = ref(new ScreeningController())
const email = ref('')

const maxEnabled = computed(() => process.env.VUE_APP_MAX_ENABLE === 'true')
const maxSendEnabled = computed(
  () => process.env.VUE_APP_UI_MAX_BLOCK_ENABLE === 'true'
)

const getUserInfo = async () => {
  const [error, response] = await userApi.getUser(userId.value)

  if (error) {
    showErrorMessage(error)
  } else {
    reportInfo.value.doctor = response.data.user
  }
}

const getFullReport = async () => {
  if (!reportId.value) return

  loading.value = true

  const [error, response] = await screeningReportApi.getReport(reportId.value)

  if (error) {
    showErrorMessage(error)
  } else {
    reportInfo.value.date_at = response.data.date_at
    screeningController.value = new ScreeningController()
    screeningController.value.setData(response.data)
    comments.value = response.data.comments
    organization.value = response.data.organization
    userId.value = response.data.user_id
    await getUserInfo()
    isSendedReport.value = response.data.report_sent_to_bot
    isLinkedPatient.value = response.data.patient.sent_to_bot
  }

  loading.value = false
}

const saveReport = async () => {
  loading.value = true

  const report = {
    examination: screeningController.value.getExaminationCellsForSend(),
    modifiedBleedingIndex:
      screeningController.value.getModifiedIndexBleedingCellsForSend(),
  }

  const [error, response] = await screeningReportApi.saveReport(
    patientId.value,
    report
  )

  if (error) {
    showErrorMessage(error)
  } else {
    ElMessage({
      message: 'Отчет сохранен',
      type: 'success',
    })

    setUpdateReportListing(true)
    loading.value = false
  }

  if (!reportId.value) {
    setUpdateReportListing(true)

    await router.push({
      name: 'ScreeningReportPage',
      params: {
        patientId: patientId.value,
        reportId: response.data.id,
      },
    })
  }
}

const updateReport = async () => {
  loading.value = true
  const report = {
    examination: screeningController.value.getExaminationCellsForSend(),
    modifiedBleedingIndex:
      screeningController.value.getModifiedIndexBleedingCellsForSend(),
    reCleaning: screeningController.value.reCleaning,
  }

  const [error] = await screeningReportApi.updateReport(reportId.value, report)

  if (error) {
    showErrorMessage(error)
  } else {
    ElMessage({
      message: 'Отчет изменён',
      type: 'success',
    })

    await getFullReport()

    setUpdateReportListing(true)
    loading.value = false
  }
}

const getCommentTemplates = async () => {
  loading.value = true

  const [error, response] = await commentApi.getCommentTemplate()
  templates.value = []

  if (error) {
    showErrorMessage(error)
  } else {
    response.data.templates.forEach((template) => {
      const newTemplate: CommentTemplateType = {
        template_id: template.id,
        template: template.template,
        isVisible: false,
      }

      templates.value.push(newTemplate)
    })
  }
}

const getPatientEmail = async (): Promise<void> => {
  const [error, response] = await patientApi.getPatientInfo(
    Number(patientId.value)
  )

  if (error) {
    showErrorMessage(error)
  } else {
    email.value = response.data.patient.email
  }
}

watch(reportId, (newReportId) => {
  if (route.name === 'ScreeningReportPage') {
    if (newReportId) {
      getFullReport()
    } else {
      screeningController.value.setInitialValues()
    }
  }
})

onMounted(() => {
  if (reportId.value) {
    getFullReport()
    getPatientEmail()
    getCommentTemplates()
  } else {
    screeningController.value.setInitialValues()
  }
})

onUnmounted(() => {
  screeningController.value.setInitialValues()
})

return (_ctx: any,_cache: any) => {
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass([{ screening__wrapper_preview: _unref(isPreviewMode) }, "screening__wrapper"])
    }, [
      (!_unref(isCreationPage))
        ? (_openBlock(), _createBlock(WReportHeader, {
            key: 0,
            "report-info": reportInfo.value,
            "report-type": "screening"
          }, null, 8, ["report-info"]))
        : _createCommentVNode("", true),
      (_unref(isPreviewMode))
        ? (_openBlock(), _createBlock(ScreeningReportPreview, {
            key: 1,
            comments: comments.value,
            organization: organization.value,
            "screening-controller": screeningController.value,
            "user-id": userId.value
          }, null, 8, ["comments", "organization", "screening-controller", "user-id"]))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(CpitnWhiteCard, {
              "screening-controller": screeningController.value,
              onUpdateReport: updateReport,
              onSaveReport: saveReport
            }, null, 8, ["screening-controller"]),
            _createVNode(IndexBloodingWhiteCard, {
              "screening-controller": screeningController.value,
              onUpdateReport: updateReport,
              onSaveReport: saveReport
            }, null, 8, ["screening-controller"]),
            (!_unref(isCreationPage))
              ? (_openBlock(), _createBlock(ScreeningRecommendations, {
                  key: 0,
                  "screening-controller": screeningController.value,
                  onUpdateReport: updateReport
                }, null, 8, ["screening-controller"]))
              : _createCommentVNode("", true),
            (!_unref(isCreationPage))
              ? (_openBlock(), _createBlock(WReportComments, {
                  key: 1,
                  comments: comments.value,
                  "is-old": false,
                  "report-type": _unref(REPORT_VIEW).screening,
                  templates: templates.value,
                  onUpdate: getFullReport
                }, null, 8, ["comments", "report-type", "templates"]))
              : _createCommentVNode("", true),
            _createVNode(_unref(WReportSubmit), {
              "report-type": _unref(REPORT_VIEW).screening,
              email: email.value
            }, null, 8, ["report-type", "email"]),
            _createVNode(_unref(WReportPrint), { "url-part": 'screening' }),
            (_unref(maxEnabled) && _unref(maxSendEnabled))
              ? (_openBlock(), _createBlock(WSendToBot, {
                  key: 2,
                  onUpdateLinkedStatus: _cache[0] || (_cache[0] = ($event: any) => (isLinkedPatient.value = true)),
                  onUpdateSendedStatus: _cache[1] || (_cache[1] = ($event: any) => (isSendedReport.value = true)),
                  "is-linked": isLinkedPatient.value,
                  "is-sended": isSendedReport.value,
                  "report-name": "screening"
                }, null, 8, ["is-linked", "is-sended"]))
              : _createCommentVNode("", true)
          ])),
      (!_unref(isCreationPage) && _unref(isPreviewMode))
        ? (_openBlock(), _createBlock(WReportHeader, {
            key: 3,
            "report-info": reportInfo.value,
            "report-type": "screening",
            position: "bottom"
          }, null, 8, ["report-info"]))
        : _createCommentVNode("", true)
    ], 2)
  ])), [
    [
      _directive_loading,
      loading.value,
      void 0,
      { body: true }
    ]
  ])
}
}

})